module.exports = __webpack_public_path__ + "static/media/suman.1d9964d3.png";